module.exports = "/dist/assets/images/audioguide.svg";